import { PlanTemplateType } from "../../templates/generated/template_types";
import type { PlaniraTemplate } from "../../templates/types";
import { ModuleDoneType, ModuleType, PlanType } from "../../templates/types";

export const EmptyTemplate: PlaniraTemplate = {
  planType: PlanType.Planira,
  title: "Empty / Blank plan",
  titleHelp: "",
  description: "Want to start from scratch? This is the option for you.",
  longDescription: "",
  emoji: "💡",
  type: PlanTemplateType.FromScratch,
  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "",
          isDraggable: false,
          emoji: "",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [],
    },
  ],
};
